module.exports = __webpack_public_path__ + "static/media/sheine_thumb_even.7dfb40a8.jpg";